module.exports = __webpack_public_path__ + "img/T86.1951d23e.jpg";